import { render, staticRenderFns } from "./Tianshine.vue?vue&type=template&id=3df4ce9e&scoped=true&"
import script from "./Tianshine.vue?vue&type=script&lang=js&"
export * from "./Tianshine.vue?vue&type=script&lang=js&"
import style0 from "./Tianshine.vue?vue&type=style&index=0&id=3df4ce9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df4ce9e",
  null
  
)

export default component.exports